import { type FunctionComponent, type ReactNode } from 'react';

// components
import { PriceAmount, type PriceAmountProps } from './PriceAmount.tsx';

interface Props extends PriceAmountProps {
    price?: number;
    originalPrice?: number;
    percentageOff?: number;
    showCompactedPrice?: boolean;
    rightDecorator?: ReactNode;
}

/**
 * Price Components for an item on sale
 *  (Sale or Sale & Original)
 */
export const SaleItemPrices: FunctionComponent<Props> = ({
    price,
    originalPrice,
    currency,
    percentageOff,
    quantityDisplay,
    hasPrivateOffer,
    appendElementToPrice,
    displayVatLabel,
    vatLabelClassName,
    priceBookName,
    showCompactedPrice = false,
    addCurrencyDataAttr,
    rightDecorator,
}) => (
    <>
        {/* SALE PRICE */}
        <PriceAmount
            type="SALE"
            currency={currency}
            amount={price}
            quantityDisplay={quantityDisplay}
            appendElementToPrice={appendElementToPrice}
            displayVatLabel={displayVatLabel}
            vatLabelClassName={vatLabelClassName}
            priceBookName={priceBookName}
            addCurrencyDataAttr={addCurrencyDataAttr}
            rightDecorator={rightDecorator}
        />
        {/* ORIGINAL PRICE */}
        {!!originalPrice && !showCompactedPrice && (
            <PriceAmount
                hasSalePrice
                discount={percentageOff}
                currency={currency}
                amount={originalPrice}
                quantityDisplay={quantityDisplay}
                hasPrivateOffer={hasPrivateOffer}
                priceBookName={priceBookName}
            />
        )}
    </>
);
